import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { useState } from "react";

type Props = {
  onClose: (isConfirmed: boolean) => void
};

export default function RemoveSubscriptionConfirmationDialog({ onClose }: Props) {
  const [confirmText, setConfirmText] = useState('')

  return (
    <Dialog open={true} maxWidth={'xs'} onClose={() => onClose(false)}>
      <DialogTitle>
        Confirm User Subscription Deletion
      </DialogTitle>
      <DialogContent dividers sx={styles.content}>
        <Typography variant="subtitle2">Are you sure that you want to <strong>REMOVE</strong> account's subscription? This action will be irreversible and can't be undone.</Typography>
        <Typography variant="subtitle2">As result of this action user's status will be set to <strong>REGISTERED</strong>.</Typography>
        <Typography variant="subtitle2">Please type "confirm" in textbox below.</Typography>
        <TextField fullWidth variant="outlined" placeholder="Confirm" onChange={
          (event: React.ChangeEvent<HTMLInputElement>) => {
            setConfirmText(event.target.value);
          }
        } />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{ width: 100, color: "#fff" }}
          disabled={confirmText !== 'confirm'}
          onClick={() => onClose(true)}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const styles = {
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  }
};